import VisaCard from "@/assets/icons/VisaCard";
import MastercardCard from "@/assets/icons/MastercardCard";
import AmexCard from "@/assets/icons/AmexCard";
import DinersClubCard from "@/assets/icons/DinersClubCard";
import HipercardCard from "@/assets/icons/HipercardCard";
import EloCard from "@/assets/icons/EloCard";
import PixMethod from "@/assets/icons/PixMethod";
import BankSlip from "@/assets/icons/BankSlip";
import { CreditCard } from "lucide-react";
import PicPayIcon from "@/assets/icons/PicPayIcon";
import GooglePayIcon from "@/assets/icons/GooglePayIcon";
import PicPaySimple from "@/assets/icons/PicPaySimpleIcon";
import PixSimple from "@/assets/icons/PixSimpleIcon";
import BoletoSimple from "@/assets/icons/BarCode";
import ApplePayIcon from "@/assets/icons/ApplePayIcon";
import GooglePaySimple from "@/assets/icons/GooglePaySimple";
import AppleSimple from "@/assets/icons/AppleSimple";
import PayPalIcon from "@/assets/icons/PayPalIcon";
import PayPalSimple from "@/assets/icons/PayPalSimple";
import VenmoIcon from "@/assets/icons/VenmoIcon";
import PazeIcon from "@/assets/icons/PazeIcon";
import VenmoSimple from "@/assets/icons/VenmoSimple";
import PazeSimple from "@/assets/icons/PazeSimple";
import PlinIcon from "@/assets/icons/PlinIcon";
import PlinSimple from "@/assets/icons/PlinSimple";
import YapeIcon from "@/assets/icons/YapeIcon";
import YapeSimple from "@/assets/icons/YapeSimple";
import ServiPagIcon from "@/assets/icons/ServiPagIcon";
import ServiPagSimple from "@/assets/icons/ServiPagSimple";
import EfectyIcon from "@/assets/icons/EfectyIcon";
import EfectySimple from "@/assets/icons/EfectySimple";
import BancoGuayaquilIcon from "@/assets/icons/BancoGuayaquilIcon";
import BancoGuayaquilSimple from "@/assets/icons/BancoGuayaquilSimple";
import BBVAContinentalIcon from "@/assets/icons/BBVAContinentalIcon";
import BBVAContinentalSimple from "@/assets/icons/BBVAContinentalSimple";
import CajaArequipaIcon from "@/assets/icons/CajaArequipaIcon";
import CajaArequipaSimple from "@/assets/icons/CajaArequipaSimple";
import CajaHuancayoIcon from "@/assets/icons/CajaHuancayoIcon";
import CajaHuancayoSimple from "@/assets/icons/CajaHuancayoSimple";
import CajaTacnaIcon from "@/assets/icons/CajaTacnaIcon";
import CajaTacnaSimple from "@/assets/icons/CajaTacnaSimple";
import CajaTrujilloIcon from "@/assets/icons/CajaTrujilloIcon";
import CajaTrujilloSimple from "@/assets/icons/CajaTrujilloSimple";
import KasnetIcon from "@/assets/icons/KasnetIcon";
import KasnetSimple from "@/assets/icons/KasnetSimple";
import RipleyIcon from "@/assets/icons/RipleyIcon";
import RipleySimple from "@/assets/icons/RipleySimple";
import WesternUnionIcon from "@/assets/icons/WesternUnionIcon";
import WesternUnionSimple from "@/assets/icons/WesternUnionSimple";
import BancoDeChileIcon from "@/assets/icons/BancoDeChileIcon";
import BancoDeChileSimple from "@/assets/icons/BancoDeChileSimple";
import BancoEstadoIcon from "@/assets/icons/BancoEstadoIcon";
import BancoEstadoSimple from "@/assets/icons/BancoEstadoSimple";
import BancoFalabellaIcon from "@/assets/icons/BancoFalabellaIcon";
import BancoFalabellaSimple from "@/assets/icons/BancoFalabellaSimple";
import BancoSantanderIcon from "@/assets/icons/BancoSantanderIcon";
import BancoSantanderSimple from "@/assets/icons/BancoSantanderSimple";
import BCIIcon from "@/assets/icons/BCIIcon";
import BCISimple from "@/assets/icons/BCISimple";
import FintocIcon from "@/assets/icons/FintocIcon";
import KhipuIcon from "@/assets/icons/KhipuIcon";
import MachIcon from "@/assets/icons/MachIcon";
import PSEIcon from "@/assets/icons/PSEIcon";
import BancoNacionalIcon from "@/assets/icons/BancoNacionalIcon";
import SPEIIcon from "@/assets/icons/SPEIIcon";
import InterbankIcon from "@/assets/icons/InterbankIcon";
import BancoNacionalSimple from "@/assets/icons/BancoNacionalSimple";
import SPEISimple from "@/assets/icons/SPEISimple";
import InterbankSimple from "@/assets/icons/InterbankSimple";
import PSESimple from "@/assets/icons/PSESimple";
import MachSimple from "@/assets/icons/MachSimple";
import KhipuSimple from "@/assets/icons/KhipuSimple";
import FintocSimple from "@/assets/icons/FintocSimple";
import BCPIcon from "@/assets/icons/BCPIcon";
import BCPSimple from "@/assets/icons/BCPSimple";
import BancoPichinchaIcon from "@/assets/icons/BancoPichinchaIcon";
import BancoPichinchaSimple from "@/assets/icons/BancoPichinchaSimple";
import MiComisariatoIcon from "@/assets/icons/MiComisariatoIcon";
import MiComisariatoSimple from "@/assets/icons/MiComisariatoSimple";
import PichinchaMiVecinoIcon from "@/assets/icons/PichinchaMiVecinoIcon";
import PichinchaMiVecinoSimple from "@/assets/icons/PichinchaMiVecinoSimple";
import BancoAztecaIcon from "@/assets/icons/BancoAztecaIcon";
import BancoAztecaSimple from "@/assets/icons/BancoAztecaSimple";
import BBVABancomerIcon from "@/assets/icons/BBVABancomerIcon";
import BBVABancomerSimple from "@/assets/icons/BBVABancomerSimple";
import CircleKIcon from "@/assets/icons/CircleKIcon";
import CircleKSimple from "@/assets/icons/CircleKSimple";
import FarmaciasDrAhorroIcon from "@/assets/icons/FarmaciasDrAhorroIcon";
import FarmaciasDrAhorroSimple from "@/assets/icons/FarmaciasDrAhorroSimple";
import FarmaciasSantaMariaIcon from "@/assets/icons/FarmaciasSantaMariaIcon";
import FarmaciasSantaMariaSimple from "@/assets/icons/FarmaciasSantaMariaSimple";
import CalimaxIcon from "@/assets/icons/CalimaxIcon";
import SorianaIcon from "@/assets/icons/SorianaIcon";
import CalimaxSimple from "@/assets/icons/CalimaxSimple";
import SorianaSimple from "@/assets/icons/SorianaSimple";
import NequiPseIcon from "@/assets/icons/NequiPseIcon";
import NequiPseSimple from "@/assets/icons/NequiPseSimple";
import OpenPayIcon from "@/assets/icons/OpenPayIcon";
import OpenPaySimple from "@/assets/icons/OpenPaySimple";
import SamsClubIcon from "@/assets/icons/SamsClubIcon";
import SamsClubSimple from "@/assets/icons/SamsClubSimple";
import ScotiabankIcon from "@/assets/icons/ScotiabankIcon";
import ScotiabankSimple from "@/assets/icons/ScotiabankSimple";
import RedActivaIcon from "@/assets/icons/RedActivaIcon";
import RedActivaSimple from "@/assets/icons/RedActivaSimple";
import SevenElevenIcon from "@/assets/icons/7ElevenIcon";
import SevenElevenSimple from "@/assets/icons/7ElevenSimple";
import OxxoIcon from "@/assets/icons/OxxoIcon";
import OxxoSimple from "@/assets/icons/OxxoSimple";
import RapipagoIcon from "@/assets/icons/RapipagoIcon";
import RapipagoSimple from "@/assets/icons/RapipagoSimple";
import BancoSupervielleIcon from "@/assets/icons/BancoSupervielleIcon";
import BancoSupervielleSimple from "@/assets/icons/BancoSupervielleSimple";
import CvuIcon from "@/assets/icons/CvuIcon";
import CvuSimple from "@/assets/icons/CvuSimple";
import QrTransferIcon from "@/assets/icons/QrTransferIcon";
import QrTransferSimple from "@/assets/icons/QrTransferSimple";
import MercadoPagoIcon from "@/assets/icons/MercadoPagoIcon";
import MercadoPagoSimple from "@/assets/icons/MercadoPagoSimple";
import ModoIcon from "@/assets/icons/ModoIcon";
import ModoSimple from "@/assets/icons/ModoSimple";
import BreBIcon from "@/assets/icons/BreBIcon";
import BreBSimple from "@/assets/icons/BreBSimple";
import SuperamaIcon from "@/assets/icons/SuperamaIcon";
import SuperamaSimple from "@/assets/icons/SuperamaSimple";
import BodegaAurreraIcon from "@/assets/icons/BodegaAurreraIcon";
import BodegaAurreraSimple from "@/assets/icons/BodegaAurreraSimple";

const brandIcons: Record<string, JSX.Element> = {
  VISA: <VisaCard />,
  MASTERCARD: <MastercardCard />,
  AMEX: <AmexCard />,
  DINERS: <DinersClubCard />,
  HIPERCARD: <HipercardCard />,
  ELO: <EloCard />,
  JCB: <CreditCard />,
  DISCOVER: <CreditCard />,
};

export function getIconMethodPayment(method: string, brand?: string) {
  if (method === "credit_card") {
    const normalizedBrand = brand?.toUpperCase();
    return normalizedBrand
      ? brandIcons[normalizedBrand] ?? <CreditCard />
      : <CreditCard />;
  }

  const methodIcons: Record<string, JSX.Element> = {
    pix: <PixMethod />,
    bank_slip: <BankSlip />,
    boleto: <BankSlip />,
    wallet_picpay: <PicPayIcon />,
    wallet_google_pay: <GooglePayIcon />,
    wallet_apple_pay: <ApplePayIcon />,
    paypal: <PayPalIcon />,
    venmo: <VenmoIcon />,
    paze: <PazeIcon />,
    plin: <PlinIcon />,
    yape: <YapeIcon />,
    servipag: <ServiPagIcon />,
    efecty: <EfectyIcon />,
    banco_azteca: <BancoAztecaIcon />,
    bbva_online: <BBVABancomerIcon />,
    bbva_cash: <BBVABancomerIcon />,
    circle_k: <CircleKIcon />,
    farmacias_dr_ahorro: <FarmaciasDrAhorroIcon />,
    farmacias_santa_maria: <FarmaciasSantaMariaIcon />,
    calimax: <CalimaxIcon />,
    soriana: <SorianaIcon />,
    nequi_pse: <NequiPseIcon />,
    openpay_cash: <OpenPayIcon />,
    sams_club: <SamsClubIcon />,
    scotiabank_online: <ScotiabankIcon />,
    scotiabank_cash: <ScotiabankIcon />,
    bbva_continental_online: <BBVAContinentalIcon />,
    bbva_continental_cash: <BBVAContinentalIcon />,
    caja_arequipa_online: <CajaArequipaIcon />,
    caja_arequipa_cash: <CajaArequipaIcon />,
    caja_huancayo_online: <CajaHuancayoIcon />,
    caja_huancayo_cash: <CajaHuancayoIcon />,
    caja_tacna_online: <CajaTacnaIcon />,
    caja_tacna_cash: <CajaTacnaIcon />,
    caja_trujillo_online: <CajaTrujilloIcon />,
    caja_trujillo_cash: <CajaTrujilloIcon />,
    kasnet: <KasnetIcon />,
    ripley: <RipleyIcon />,
    western_union: <WesternUnionIcon />,
    banco_chile: <BancoDeChileIcon />,
    banco_estado: <BancoEstadoIcon />,
    banco_falabella: <BancoFalabellaIcon />,
    banco_santander: <BancoSantanderIcon />,
    bank_bci: <BCIIcon />,
    fintoc: <FintocIcon />,
    khipu: <KhipuIcon />,
    mach: <MachIcon />,
    pse: <PSEIcon />,
    bre_b: <BreBIcon />,
    spei: <SPEIIcon />,
    banco_nacional_online: <BancoNacionalIcon />,
    banco_credito_online: <BCPIcon />,
    banco_credito_cash: <BCPIcon />,
    interbank_online: <InterbankIcon />,
    banco_guayaquil_online: <BancoGuayaquilIcon />,
    banco_guayaquil_cash: <BancoGuayaquilIcon />,
    banco_pichincha_online: <BancoPichinchaIcon />,
    banco_pichincha_cash: <BancoPichinchaIcon />,
    mi_comisariato: <MiComisariatoIcon />,
    pichincha_mi_vecino: <PichinchaMiVecinoIcon />,
    red_activa: <RedActivaIcon />,
    seven_eleven: <SevenElevenIcon />,
    oxxo: <OxxoIcon />,
    rapipago: <RapipagoIcon />,
    banco_supervielle: <BancoSupervielleIcon />,
    cvu: <CvuIcon />,
    qr_transfer: <QrTransferIcon />,
    mercado_pago: <MercadoPagoIcon />,
    modo: <ModoIcon />,
    khipu_argentina: <KhipuIcon />,
    superama: <SuperamaIcon />,
    bodega_aurrera: <BodegaAurreraIcon />,
  };

  return methodIcons[method] ?? null;
}

export function getIconMethodPaymentSimple(method: string) {
  const methodIcons: Record<string, JSX.Element> = {
    credit_card: <CreditCard />,
    pix: <PixSimple />,
    bank_slip: <BoletoSimple />,
    boleto: <BoletoSimple />,
    wallet_picpay: <PicPaySimple />,
    wallet_google_pay: <GooglePaySimple />,
    wallet_apple_pay: <AppleSimple />,
    paypal: <PayPalSimple />,
    venmo: <VenmoSimple />,
    paze: <PazeSimple />,
    plin: <PlinSimple />,
    yape: <YapeSimple />,
    servipag: <ServiPagSimple />,
    efecty: <EfectySimple />,
    banco_azteca: <BancoAztecaSimple />,
    bbva_online: <BBVABancomerSimple />,
    bbva_cash: <BBVABancomerSimple />,
    circle_k: <CircleKSimple />,
    farmacias_dr_ahorro: <FarmaciasDrAhorroSimple />,
    farmacias_santa_maria: <FarmaciasSantaMariaSimple />,
    calimax: <CalimaxSimple />,
    soriana: <SorianaSimple />,
    nequi_pse: <NequiPseSimple />,
    openpay_cash: <OpenPaySimple />,
    sams_club: <SamsClubSimple />,
    scotiabank_online: <ScotiabankSimple />,
    scotiabank_cash: <ScotiabankSimple />,
    bbva_continental_online: <BBVAContinentalSimple />,
    bbva_continental_cash: <BBVAContinentalSimple />,
    caja_arequipa_online: <CajaArequipaSimple />,
    caja_arequipa_cash: <CajaArequipaSimple />,
    caja_huancayo_online: <CajaHuancayoSimple />,
    caja_huancayo_cash: <CajaHuancayoSimple />,
    caja_tacna_online: <CajaTacnaSimple />,
    caja_tacna_cash: <CajaTacnaSimple />,
    caja_trujillo_online: <CajaTrujilloSimple />,
    caja_trujillo_cash: <CajaTrujilloSimple />,
    kasnet: <KasnetSimple />,
    ripley: <RipleySimple />,
    western_union: <WesternUnionSimple />,
    banco_chile: <BancoDeChileSimple />,
    banco_estado: <BancoEstadoSimple />,
    banco_falabella: <BancoFalabellaSimple />,
    banco_santander: <BancoSantanderSimple />,
    bank_bci: <BCISimple />,
    fintoc: <FintocSimple />,
    khipu: <KhipuSimple />,
    mach: <MachSimple />,
    pse: <PSESimple />,
    bre_b: <BreBSimple />,
    spei: <SPEISimple />,
    banco_nacional_online: <BancoNacionalSimple />,
    banco_credito_online: <BCPSimple />,
    banco_credito_cash: <BCPSimple />,
    interbank_online: <InterbankSimple />,
    banco_guayaquil_online: <BancoGuayaquilSimple />,
    banco_guayaquil_cash: <BancoGuayaquilSimple />,
    banco_pichincha_online: <BancoPichinchaSimple />,
    banco_pichincha_cash: <BancoPichinchaSimple />,
    mi_comisariato: <MiComisariatoSimple />,
    pichincha_mi_vecino: <PichinchaMiVecinoSimple />,
    red_activa: <RedActivaSimple />,
    seven_eleven: <SevenElevenSimple />,
    oxxo: <OxxoSimple />,
    rapipago: <RapipagoSimple />,
    banco_supervielle: <BancoSupervielleSimple />,
    cvu: <CvuSimple />,
    qr_transfer: <QrTransferSimple />,
    mercado_pago: <MercadoPagoSimple />,
    modo: <ModoSimple />,
    khipu_argentina: <KhipuSimple />,
    superama: <SuperamaSimple />,
    bodega_aurrera: <BodegaAurreraSimple />,
  };

  return methodIcons[method] ?? null;
}